module.exports = __webpack_public_path__ + "static/meet-concierge-desktop-c40c7fd330cd7942eb89f345d4d1b74e.png";